<script setup>
  import { computed } from 'vue';
  import { useMediaQuery } from '@/composables/useMediaQuery';
  import CompleteReportDataContainerSection from '@/components/CompleteReportDataContainerSection.vue';
  import UpgradeButton from '@/components/UpgradeButton.vue';
  import DataContainer from '@/components/DataContainer.vue';
  import useSettingsGlobals from '@/composables/useSettingsGlobals';

  const { $WEB_VIEW } = useSettingsGlobals();     

  const props = defineProps({
    upgrade: {
      type: Array,
      required: true
    }
  });

  const isDesktop = useMediaQuery('(min-width: 840px)');

  const messageText = computed(() => {
    if (props.upgrade[1].length === 0) {
      if ($WEB_VIEW) return `Upgrade your app to view the <strong>Gorge Windbow</strong> data.`;

      return `Upgrade to view the <strong>Gorge Windbow</strong> data.`
    }
    
    return `Upgrade to <strong>${formatMembershipLevels(props.upgrade[1])}</strong> to view the <strong>Gorge Windbow</strong> data.`;
  });  

  const buttonText = computed(() => {
    if (props.upgrade[2] === null) return 'Upgrade Now';

    return props.upgrade[2] ? 'Start Free Trial' : 'Upgrade Now';
  });  

  const showButton = computed(() => $WEB_VIEW && props.upgrade[1].length === 0 ? false : true);
  const minHeight = computed(() => isDesktop.value ? '474px' : '507px');

  // TODO: move to composable?
  function formatMembershipLevels(levels) {
    return levels.map((level, i) => {
      const capitalizedLevel = `${level[0].toUpperCase()}${level.slice(1)}`;

      if (i === 0) return capitalizedLevel;

      if (levels.length > 2) {
        return i < levels.length - 1 
          ? `, ${capitalizedLevel}` 
          : `, or ${capitalizedLevel}`
      };

      return ` or ${capitalizedLevel}`
    }).join('');
  }    
</script>

<template>
    <CompleteReportDataContainerSection
      sectionId="gorge-windbow"
      title="Gorge Windbow"
      containerTypeId="Gorge Windbow"
      :metaActions="false"
      :minHeight="minHeight"
    >
      <template #content="{ isVisible }">
        <DataContainer v-if="isVisible" style="overflow: hidden;">
          <div class="jwx-data-container__background-image">
            <div class="jwx-data-container__upgrade-content">
              <div class="jwx-data-container__upgrade-block"></div>
              <div class="jwx-data-container__upgrade-message">
                <p v-html="messageText"></p>
                <UpgradeButton v-if="showButton" :buttonText="buttonText" />
              </div>

              <div class="jwx-data-container__upgrade-preview">
                <img src="../assets/images/upgrade/windbow-preview.webp" class="jwx-data-container__upgrade-image" />
              </div>
            </div>

            <img src="../assets/images/upgrade/windbow-blurred.jpg"  class="jwx-data-container__upgrade-bg-image" />
          </div>
        </DataContainer>
      </template>
    </CompleteReportDataContainerSection>
</template>